import request from '@/api/request'

export function defFetchList (basePath, query) {
  return request({
    url: basePath,
    method: 'get',
    params: query
  })
}

export function defFetchOne (basePath, id) {
  return request({
    url: basePath + '/' + id,
    method: 'get'
  })
}

export function defFetchField (basePath, id, field, params) {
  return request({
    url: basePath + '/' + id + '/' + field,
    method: 'get',
    params: params
  })
}

export function defFetchFields (basePath) {
  return request({
    url: basePath + '/0/fields',
    method: 'get'
  })
}

export function defCreate (basePath, data) {
  return request({
    url: basePath,
    method: 'post',
    data
  })
}

export function defUpdate (basePath, data) {
  return request({
    url: basePath,
    method: 'put',
    data
  })
}

export function defCreateWithQuery (basePath, query, data) {
  return request({
    url: basePath,
    method: 'post',
    params: query,
    data
  })
}

export function defUpdateOne (basePath, id, data) {
  return request({
    url: basePath + '/' + id,
    method: 'put',
    data
  })
}

export function defUpdateStatus (basePath, id, data) {
  return request({
    url: basePath + '/' + id + '/status',
    method: 'put',
    data
  })
}

export function defUpdateBookingTime (basePath, id, data) {
  return request({
    url: basePath + '/' + id + '/bookingtime',
    method: 'put',
    data
  })
}

export function defUploadCertFile (basePath, id, data, config) {
  return request({
    url: basePath + '/' + id + '/cert',
    method: 'post',
    data,
    config
  })
}

export function defDeleteCert (basePath, id) {
  return request({
    url: basePath + '/' + id + '/cert',
    method: 'delete'
  })
}

export function defDeleteOne (basePath, id) {
  return request({
    url: basePath + '/' + id,
    method: 'delete'
  })
}

export function defUploadCoverImage (basePath, id, data, config, routeSuffix = 'cover_image') {
  return request({
    url: basePath + '/' + routeSuffix + ((id === '0') ? '' : '/' + id),
    method: 'post',
    data,
    config
  })
}

export function defUploadAlbumImage (basePath, id, data, config) {
  return request({
    url: basePath + '/album_image' + ((id === '0') ? '' : '/' + id),
    method: 'post',
    data,
    config
  })
}

export function defUpdateAlbumImage (basePath, id, data) {
  return request({
    url: basePath + '/' + id + '/album_image',
    method: 'put',
    data
  })
}

export function defDeleteAlbumImage (basePath, id) {
  return request({
    url: basePath + '/' + id + '/album_image',
    method: 'delete'
  })
}

export function defCreateOrdersNotify (basePath, data = {}) {
  return request({
    url: basePath + '/orders_notify',
    method: 'post',
    data
  })
}

export function cusUpdateOne (basePath, id, path, data) {
  return request({
    url: basePath + '/' + id + '/' + path,
    method: 'put',
    data
  })
}
